import {GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import styled, {css} from 'styled-components'

export const StyledGridItem = styled(GridItem)(
    ({theme: {mediaQueries}}) => css`
        grid-column: span 3;
        ${mediaQueries['2xl']} {
            grid-column: span 4;
        }
        ${mediaQueries['xl']} {
            grid-column: span 6;
        }
    `
)
